/**
 * Fremdriftens farve - den samme på TV-skærmen og ved sagerne (Simon 2026-10-28):
 * under 25 % rød, 25-89 % gul, 90 % og derover grøn.
 *
 * Bjælken bruger de klare farver. Tallet på de lyse sider bruger en mørkere nuance
 * af samme farve, for gul tekst kan ikke læses på hvid baggrund.
 */
export type ProgressLevel = 'low' | 'mid' | 'high'

export function progressLevel(percent: number): ProgressLevel {
  if (percent < 25) return 'low'
  if (percent < 90) return 'mid'
  return 'high'
}

const barColors: Record<ProgressLevel, string> = { low: '#EF4444', mid: '#FACC15', high: '#22C55E' }
const textColors: Record<ProgressLevel, string> = { low: '#DC2626', mid: '#A16207', high: '#15803D' }

/** Bjælken - og tallet på TV'ets mørke baggrund. */
export function progressColor(percent: number): string {
  return barColors[progressLevel(percent)]
}

/** Tallet på lys baggrund. */
export function progressTextColor(percent: number): string {
  return textColors[progressLevel(percent)]
}
